<script>
    export default {
        name: 'Blank',
        render: () => null,
    }
</script>
